import httpClient from '../httpClient';

export default {
  getAll() {
    return httpClient('v0.4').get('/terms_and_conditions_versions', {
      params: { current: true }
    });
  }
};
